import css from 'styled-jsx/css';
import { common } from '../../../../theme/theme';

const style = css`
  .purpose-status-modal {
    width: 400px;
    padding: 16px;
    max-height: 800px;
    overflow-y: auto;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .period-label {
    font-size: 15px;
    margin-top: 12px;
    margin-bottom: 4px;
    font-weight: 600;
  }
  .radio-wrapper {
    display: flex;
    flex-direction: column;
    padding: 8px 0;
    margin-bottom: 20px;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .purpose-modal-inputs {
    margin-bottom: 8px;
  }
  .status-selector-wrapper,
  .reason-selector-wrapper,
  .circle-selector-wrapper {
    margin-bottom: 8px;
  }
  .comment-form {
    margin-bottom: 16px;
  }
  .purpose-status-modal :global(textarea.text-area) {
    resize: none;
    border: solid 1px #676767;
    border-radius: 4px;
    font-size: 16px;
  }
  .purpose-status-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .purpose-status-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .clear-checkbox {
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .comment-area {
    border: 1px solid #676767;
    border-radius: 4px;
    width: 100%;
    height: 90px;
    resize: none;
  }
  .override-add {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    color: #0077be;
    margin-top: 4px;
  }
  .override-add img {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
  .override-hint {
    font-size: 12px;
    color: #666668;
    margin-top: 8px;
  }
  .override-warning {
    font-size: 12px;
    color: #c0392b;
    margin-top: 8px;
  }
`;

export default style;
